var map = {
	"./stats-browsers-africa.json": 329,
	"./stats-browsers-asia.json": 330,
	"./stats-browsers-belarus.json": 331,
	"./stats-browsers-china.json": 332,
	"./stats-browsers-europe.json": 333,
	"./stats-browsers-germany.json": 334,
	"./stats-browsers-india.json": 335,
	"./stats-browsers-kazakhstan.json": 336,
	"./stats-browsers-north-america.json": 337,
	"./stats-browsers-oceania.json": 338,
	"./stats-browsers-russian-federation.json": 339,
	"./stats-browsers-south-america.json": 340,
	"./stats-browsers-ukraine.json": 341,
	"./stats-browsers-united-states-of-america.json": 342,
	"./stats-browsers-worldwide.json": 343,
	"./stats-date.json": 196
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 328;